import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './App.css';
import StarBackground from './components/StarBackground';


// Components
const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  // const navigate = useNavigate();

  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Function to toggle the mobile menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Function to close the mobile menu after navigating
  const handleLinkClick = (sectionId) => {
    handleScroll(sectionId);
    setIsOpen(false); // Close the menu after a link is clicked
  };

  return (
    <nav className="bg-gray-900 bg-opacity-80 py-4 px-10 sticky top-0 z-50 backdrop-filter backdrop-blur-lg">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold flex items-center nebula-text">
          BeyondTheHorizon
        </Link>
        <div className="hidden md:flex space-x-4">
          <button onClick={() => handleScroll('home')} className="hover:text-blue-400 transition duration-300">Home</button>
          <button onClick={() => handleScroll('events')} className="hover:text-blue-400 transition duration-300">Events</button>
          <button onClick={() => handleScroll('gallery')} className="hover:text-blue-400 transition duration-300">Gallery</button>
          <button onClick={() => handleScroll('resources')} className="hover:text-blue-400 transition duration-300">Resources</button>
          <button onClick={() => handleScroll('about')} className="hover:text-blue-400 transition duration-300">About Us</button>
          <button onClick={() => handleScroll('contact')} className="hover:text-blue-400 transition duration-300">Contact</button>
          <button onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSdkyZ19LpgXiCCROqRDdl6oLAFm1HfXxJnfMmVsDj_OpLIU5w/viewform?usp=sf_link', '_blank')} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-300">Join Us</button>
        </div>
        <button onClick={toggleMenu} className="md:hidden text-white">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="small-screen-menu md:hidden">
          <button onClick={() => handleLinkClick('home')} className="block py-2 px-4 text-sm hover:bg-gray-700">Home</button>
          <button onClick={() => handleLinkClick('events')} className="block py-2 px-4 text-sm hover:bg-gray-700">Events</button>
          <button onClick={() => handleLinkClick('gallery')} className="block py-2 px-4 text-sm hover:bg-gray-700">Gallery</button>
          <button onClick={() => handleLinkClick('resources')} className="block py-2 px-4 text-sm hover:bg-gray-700">Resources</button>
          <button onClick={() => handleLinkClick('about')} className="block py-2 px-4 text-sm hover:bg-gray-700">About Us</button>
          <button onClick={() => handleLinkClick('contact')} className="block py-2 px-4 text-sm hover:bg-gray-700">Contact</button>
          <button onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSdkyZ19LpgXiCCROqRDdl6oLAFm1HfXxJnfMmVsDj_OpLIU5w/viewform?usp=sf_link', '_blank')} className="block py-2 px-4 text-sm bg-blue-600 text-white hover:bg-blue-700 transition duration-300">Join Us</button>
        </div>
      )}
    </nav>
  );
};

const Header = () => (
  <header id="home" className="py-20 text-center galaxy-bg">
    <div className="bg-opacity-50 p-8 inline-block rounded-lg">
      <h1 className="text-5xl font-bold mb-4 nebula-text float-animation">Explore the Cosmos</h1>
      <p className="text-xl">Join us in our celestial adventures!</p>
      <a href="#events" className="mt-8 inline-block bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition duration-300 transform hover:scale-105">Discover Our Events</a>
    </div>
  </header>
);

const EventCard = ({ title, description, date }) => (
  <div className="event-card bg-gray-800 p-6 rounded-lg shadow-lg">
    <h3 className="text-xl font-semibold mb-2">{title}</h3>
    <p>{description}</p>
    <p className="mt-4">Date: {date}</p>
    <a href="/calendar" className="mt-4 inline-block bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-300">Learn More</a>
  </div>
);

const Events = () => (
  <section id="events" className="my-20">
    <h2 className="text-3xl font-bold mb-8 nebula-text">Upcoming Events</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <EventCard
        title="Planet Viewing Night"
        description="Join us for an evening of observing Jupiter and its moons!"
        date="October 12, 2024"
      />
      <EventCard
        title="Moon Gazing Workshop"
        description="Learn about lunar features and observe them through our telescopes."
        date="October 19, 2024"
      />
      <EventCard
        title="Kids' Stargazing Adventure"
        description="A fun-filled night for children to explore the wonders of the night sky."
        date="October 20, 2024"
      />
    </div>
  </section>
);

const Gallery = () => {
  const [modalImage, setModalImage] = useState(null);
  const [modalCaption, setModalCaption] = useState('');

  const openModal = (imageSrc, caption) => {
    setModalImage(imageSrc);
    setModalCaption(caption);
  };

  const closeModal = () => {
    setModalImage(null);
    setModalCaption('');
  };

  return (
    <section id="gallery" className="my-20">
      <h2 className="text-3xl font-bold mb-8 nebula-text">Celestial Gallery</h2>
      <div className="image-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="relative group image-container">
          <img src="/assets/imgs/andromeda.jpg" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-lg font-bold">Andromeda Galaxy</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/andromeda.jpg', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
        <div className="relative group image-container">
          <img src="/assets/imgs/comet.jpg" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-lg font-bold">Panstar Comet</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/comet.jpg', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
        <div className="relative group image-container">
          <img src="/assets/imgs/cone-x-mas-nebula.jpg" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-md font-bold">Cone and the X-mas tree Nebula</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/cone-x-mas-nebula.jpg', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
        <div className="relative group image-container">
          <img src="/assets/imgs/flame-horse-head.jpg" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-md font-bold">Flame and the Horse head Nebula</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/flame-horse-head.jpg', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
        <div className="relative group image-container">
          <img src="/assets/imgs/rosett-nebula.jpg" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-lg font-bold">Rosette Nebula</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/rosett-nebula.jpg', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
        <div className="relative group image-container">
          <img src="/assets/imgs/whale-hockey-stick-galaxy.png" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-md font-bold">Whale and the Hockey stick Galaxy</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/whale-hockey-stick-galaxy.png', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
        <div className="relative group image-container">
          <img src="/assets/imgs/whirlpool-galaxy.jpg" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-lg font-bold">Whirlpool Galaxy</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/whirlpool-galaxy.jpg', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
        <div className="relative group image-container">
          <img src="/assets/imgs/moon.jpeg" alt="Galaxy" className="w-full h-full object-cover rounded-lg shadow-md cursor-pointer zoom-image" />
          <div className="absolute inset-0 transparent bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4 rounded-lg">
            <span className="text-white text-lg font-bold">Moon</span>
          </div>
          <button
            className="absolute top-2 right-2 bg-white text-gray-800 rounded-full w-8 h-8 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            onClick={() => openModal('/assets/imgs/moon.jpeg', 'Stunning galaxy captured by our club members')}
          >
            +
          </button>
        </div>
      </div>
      {modalImage && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={closeModal}>
          <div className="max-w-3xl max-h-full">
            <img src={modalImage} alt="Modal" className="max-w-full max-h-full" />
            <p className="text-white text-center mt-4">{modalCaption}</p>
          </div>
        </div>
      )}
    </section>
  );
};

const Resources = () => {
  const [showBeginnerGuide, setShowBeginnerGuide] = useState(false);

  return (
    <section id="resources" className="my-20">
      <h2 className="text-3xl font-bold mb-8 nebula-text">Astronomy Resources</h2>
      <div className="grid grid-cols-1 gap-8">
        <div className="bg-gray-800 p-6 rounded-lg shadow-lg event-card transition-transform duration-300 ease-in-out hover:shadow-2xl hover:scale-105">
          <h3 className="text-2xl font-bold mb-4 text-white">Beginner's Guide to Stargazing</h3>
          <ul className="list-disc list-inside mb-4 text-gray-300">
            <li>Identifying constellations</li>
            <li>Using star charts effectively</li>
            <li>Choosing the right telescope</li>
          </ul>

          <button
            onClick={() => setShowBeginnerGuide(!showBeginnerGuide)}
            className="text-blue-400 font-semibold hover:underline focus:outline-none focus:ring-2 focus:ring-blue-400 transition duration-150"
          >
            {showBeginnerGuide ? 'Read Less' : 'Read More'}
          </button>

          {showBeginnerGuide && (
            <div className="mt-6 p-4 bg-gray-700 rounded-lg text-gray-300">
              <p className="text-lg mb-4 leading-relaxed">
                Stargazing is a magical experience that connects us to the vast universe. Here's a more detailed beginner’s guide to help you take your first steps:
              </p>

              <h4 className="text-xl font-semibold text-blue-300 mt-6 mb-2">1. Start with Naked-Eye Observations</h4>
              <p className="leading-relaxed mb-4">
                Before investing in any equipment, spend time learning the night sky with your naked eyes. Get to know the brightest stars and most recognizable constellations like Orion, Ursa Major, and Cassiopeia. The more familiar you become, the easier it will be to navigate when using binoculars or a telescope later on.
              </p>

              <h4 className="text-xl font-semibold text-blue-300 mt-6 mb-2">2. Identifying Constellations</h4>
              <p className="leading-relaxed mb-4">
                Constellations are like landmarks in the sky. Start by focusing on a few key constellations that are visible year-round in your region. Orion's Belt, the Big Dipper, and the Southern Cross are excellent starting points. Using a constellation guide or app can help you visualize and track these formations as they move through the night.
              </p>

              <h4 className="text-xl font-semibold text-blue-300 mt-6 mb-2">3. Using Star Charts and Apps</h4>
              <p className="leading-relaxed mb-4">
                Star charts, both physical and digital, are essential for finding stars, planets, and deep-sky objects. Printed star charts give you a great sense of scale and movement, while apps like <strong>SkySafari</strong> or <strong>Star Walk</strong> offer real-time guides and augmented reality views, making it easier to align what you see on the screen with the sky above.
              </p>

              <h4 className="text-xl font-semibold text-blue-300 mt-6 mb-2">4. Choosing Your First Telescope</h4>
              <p className="leading-relaxed mb-4">
                Before buying a telescope, start with binoculars. A good pair of 7x50 or 10x50 binoculars is perfect for viewing the Moon, star clusters, and even some galaxies. When you're ready to upgrade, consider a telescope based on your goals and budget. A <strong>Dobsonian</strong> telescope is often recommended for beginners because of its affordability and large aperture, which gathers more light for clearer, brighter views.
              </p>

              <h4 className="text-xl font-semibold text-blue-300 mt-6 mb-2">5. Timing and Location</h4>
              <p className="leading-relaxed mb-4">
                The best time for stargazing is during a new moon when the sky is darkest, and far away from city lights to avoid light pollution. Use websites like <strong>ClearDarkSky</strong> or apps like <strong>Dark Sky Finder</strong> to locate nearby dark-sky parks or other ideal stargazing spots.
              </p>

              <h4 className="text-xl font-semibold text-blue-300 mt-6 mb-2">6. Join a Local Astronomy Club</h4>
              <p className="leading-relaxed mb-4">
                Joining a local astronomy club (like ours!) is one of the best ways to learn. Experienced stargazers can offer guidance, let you try different types of equipment, and even provide opportunities to view celestial events like meteor showers, eclipses, and planet transits. Plus, group observation nights can be a lot of fun!
              </p>

              <h4 className="text-xl font-semibold text-blue-300 mt-6 mb-2">7. Patience and Enjoyment</h4>
              <p className="leading-relaxed mb-4">
                Finally, stargazing is a hobby that rewards patience. Celestial objects don’t always reveal their beauty instantly, but with practice, your skills will grow, and the night sky will become an endless source of wonder.
              </p>
            </div>
          )}
        </div>

        <div className="bg-gray-800 p-6 rounded-lg shadow-lg event-card">
          <h3 className="text-xl font-semibold mb-4">Astronomical Phenomena 2024</h3>
          <ul className="list-disc list-inside">
            <li>Meteor showers</li>
            <li>Planetary alignments</li>
            <li>Lunar and solar eclipses</li>
          </ul>
          <Link to="/calendar" className="mt-4 inline-block bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-300">View Calendar</Link>
        </div>
      </div>
    </section>
  );
};

const About = () => (
  <section id="about" className="my-20">
    <h2 className="text-3xl font-bold mb-8 nebula-text">About StarGazers</h2>
    <div className="bg-gray-800 p-8 rounded-lg shadow-lg flex items-center">
      <div className="mr-8">
        <p class="text-lg mb-4">We are a passionate group of amateur astronomers dedicated to sharing the wonders of the universe with our community. Our mission is to spark a love for science and astronomy in people of all ages, especially children and underprivileged youth.</p>
        <p class="text-lg mb-4">Founded in 2024, BeyondTheHorizon has grown from a small group of enthusiasts to a thriving community. We organize regular stargazing events, workshops, and educational programs for schools and community centers.</p>
        <p class="text-lg">Join us in our mission to inspire the next generation of astronomers and space enthusiasts!</p>

      </div>
      {/* <div className="planet hidden lg:block"></div> */}
    </div>
  </section>
);

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const response = await fetch(
        "https://formspree.io/f/xnnaekrl", // Replace with your Formspree form ID
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setSubmitMessage('Message sent successfully!');
        setFormData({ name: '', email: '', message: '' });
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmitMessage('Failed to send message. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="my-20">
      <h2 className="text-3xl font-bold mb-8 nebula-text">Contact Us</h2>
      <form onSubmit={handleSubmit} action="https://formspree.io/f/xnnaekrl" method="post" className="max-w-lg mx-auto bg-gray-800 p-8 rounded-lg shadow-lg">
        <div className="mb-4">
          <label htmlFor="name" className="block mb-2">Name</label>
          <input
            type="text"
            id="name"
            className="w-full p-2 bg-gray-700 rounded text-white"
            required
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block mb-2">Email</label>
          <input
            type="email"
            id="email"
            className="w-full p-2 bg-gray-700 rounded text-white"
            required
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="message" className="block mb-2">Message</label>
          <textarea
            id="message"
            className="w-full p-2 bg-gray-700 rounded text-white"
            rows="4"
            required
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>
        <button 
          type="submit" 
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-300 transform hover:scale-105"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Sending...' : 'Send'}
        </button>
        {submitMessage && (
          <p className={`mt-4 ${submitMessage.includes('successfully') ? 'text-green-500' : 'text-red-500'}`}>
            {submitMessage}
          </p>
        )}
      </form>
    </section>
  );
};

const Footer = () => (
  <footer className="bg-gray-900 py-8 text-center">
    <div className="container mx-auto px-4">
      <p className="mb-4">&copy; 2024 BeyondTheHorizon Astronomy Club. All rights reserved.</p>
    </div>
  </footer>
);

const Home = () => (
  <>
    <Header />
    <main className="container mx-auto px-10 py-10">
      <Events />
      <Gallery />
      <Resources />
      <About />
      <Contact />
    </main>
  </>
);

// const Join = () => (
//   <div className="container mx-auto px-4 py-20">
//     <div className="form-container mx-auto max-w-3xl">
//       <h1 className="text-4xl font-bold text-center mb-6 nebula-text float-animation">
//         Join Our Community
//       </h1>
//       <p className="text-lg text-center mb-10">
//         Fill in the form below to become a part of our awesome community. We look forward to having you!
//       </p>

//       <form className="join-form" action="/submit-form" method="post">
//         <input
//           type="text"
//           name="full_name"
//           placeholder="Full Name"
//           className="p-4 w-full rounded-lg bg-gray-700 mb-4"
//           required
//         />
//         <input
//           type="email"
//           name="email"
//           placeholder="Email Address"
//           className="p-4 w-full rounded-lg bg-gray-700 mb-4"
//           required
//         />
//         <input
//           type="tel"
//           name="phone"
//           placeholder="Phone Number"
//           className="p-4 w-full rounded-lg bg-gray-700 mb-4"
//           required
//         />
//         <textarea
//           name="message"
//           rows="5"
//           placeholder="Tell us about yourself..."
//           className="p-4 w-full rounded-lg bg-gray-700 mb-4"
//           required
//         />
//         <button
//           type="submit"
//           className="w-full bg-blue-500 text-white py-3 rounded-lg font-semibold transition duration-300 hover:bg-blue-600"
//         >
//           Join Now
//         </button>
//       </form>
//     </div>
//   </div>
// );


const Calendar = () => {
  return (
    <div className="space-gradient text-white">
      <div id="stars"></div>
      <div id="shooting-stars"></div>

      {/* Navbar */}
      <nav className="bg-gray-900 bg-opacity-80 py-4 px-10 sticky top-0 z-50 backdrop-filter backdrop-blur-lg">
        <div className="container mx-auto flex justify-between items-center">
          <a href="/" className="text-2xl font-bold flex items-center nebula-text">
            BeyondTheHorizon
          </a>
          <button id="small-screen-menu-button" className="md:hidden text-white">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>
      </nav>

      {/* Header Section */}
      <header className="py-20 text-center galaxy-bg">
        <div className="bg-black bg-opacity-50 p-8 inline-block rounded-lg">
          <h1 className="text-5xl font-bold mb-4 nebula-text">
            Events Calendar
          </h1>
          <p className="text-xl">Discover all upcoming celestial events at a glance.</p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-10 py-10">
        <section className="my-20">
          <h2 className="text-3xl font-bold mb-8 nebula-text">Event Schedule</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Event 1 */}
            <div className="event-card bg-gray-800 p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Planet Viewing Night</h3>
              <p>Join us for an evening of observing Jupiter and its moons!</p>
              <p className="mt-4">
                <strong>Date:</strong> October 12, 2024
              </p>
              <p>
                <strong>Location:</strong> 24/421, Shipra Path, Mansarovar Sector
                6, Jaipur(Raj), India
              </p>
              <p>
                <strong>Time:</strong> 8:00 PM - 11:00 PM
              </p>
            </div>

            {/* Event 2 */}
            <div className="event-card bg-gray-800 p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Moon Gazing Workshop</h3>
              <p>Learn about lunar features and observe them through our telescopes.</p>
              <p className="mt-4">
                <strong>Date:</strong> October 19, 2024
              </p>
              <p>
                <strong>Location:</strong> Govt Senior Secondary School, Kherli,
                Alwar(Raj.)
              </p>
              <p>
                <strong>Time:</strong> 7:30 PM - 10:00 PM
              </p>
            </div>

            {/* Event 3 */}
            <div className="event-card bg-gray-800 p-6 rounded-lg shadow-lg">
              <h3 className="text-xl font-semibold mb-2">Kids' Stargazing Adventure</h3>
              <p>A fun-filled night for children to explore the wonders of the night sky.</p>
              <p className="mt-4">
                <strong>Date:</strong> October 20, 2024
              </p>
              <p>
                <strong>Location:</strong> Govt Kanya School, Kalwari, Alwar(Raj.)
              </p>
              <p>
                <strong>Time:</strong> 6:00 PM - 9:00 PM
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};




const App = () => {
  // For detecting the current location
  const location = useLocation();

  useEffect(() => {
    document.body.classList.add('loaded');
  }, []);

  return (
    <div className="space-gradient text-white">
      <div id="stars"></div>
      <div id="shooting-stars"></div>
      <StarBackground/>

      {/* Conditionally render the Navigation component */}
      {location.pathname === '/' && <Navigation />}

      <main className="flex-grow overflow-y-auto">
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/join" element={<Join />} /> */}
        <Route path="/calendar" element={<Calendar />} />
      </Routes>
      </main>
      <Footer />
    </div>
  );
};

const Wrapper = () => (
  <Router>
    <App />
  </Router>
);

export default Wrapper;


// const App = () => {  
//     useEffect(() => {
//       document.body.classList.add('loaded');
//     }, []);
  
//     return (
//       <Router>
// <div className="space-gradient text-white">
//         <div id="stars"></div>
//         <div id="shooting-stars"></div>
//         <StarBackground/>
  
//         {/* Conditionally render the Navigation component */}
//         <Navigation />
  
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/join" element={<Join />} />
//           <Route path="/calendar" element={<Calendar />} />
//         </Routes>
  
//         <Footer />
//       </div>
//       </Router>
      
//     );
//   };
  
  
//   export default App;